const CryptoJS = require("crypto-js");

export default class Cipher {

    static airtelE_D_Key = 'A!rt3lOnl!n33ncrypt30n5tr!ngHJS3cur!ty';

    encrypt = (message) => {
        if (message===undefined || message===null) return message;
        if (typeof message === 'object') {
            message = JSON.stringify(message);
        } else {
            message = String(message);
        }
        let keyHex = CryptoJS.enc.Utf8.parse(this.airtelE_D_Key);
        let encrypted = CryptoJS.DES.encrypt(message, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    };
    
    decrypt = (ciphertext) => {
        if (!ciphertext) return ciphertext;
        let keyHex = CryptoJS.enc.Utf8.parse(this.airtelE_D_Key);
        // direct decrypt ciphertext
        let decrypted = CryptoJS.DES.decrypt({
            ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
        }, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        let message = decrypted.toString(CryptoJS.enc.Utf8);
    
        //if encryption source was object
        try {
            message = JSON.parse(message);
            return message;
        } catch (err) {
            //if encryption source was string
            return message;
        }
    }
    

}